import { styled } from '@mui/system'

export const MfaTitle = styled('div')`
    margin-bottom: 8px;
`

export const MfaDescription = styled('div')`
    margin-bottom: 24px;
    max-width: 520px;
`
